<template>
    <div>
        <input
            ref="input"
            v-model="value"
            :inputmode="isDropdownOpen ? 'text' : 'none'"
            class="vrm-date-time-picker__dropdown__custom-time"
            type="text"
            placeholder="HH:MM"
            @focus="handleFocus"
            @blur="handleBlur"
        />
        <div v-show="isDropdownOpen" class="vrm-date-time-picker__dropdown__custom-time-dropdown">
            <div
                ref="timeChoices"
                class="vrm-date-time-picker__dropdown__custom-time-dropdown__choices"
            >
                <div
                    v-for="(time, idx) in timeChoices"
                    :key="'custom-time-' + uniqueKeyString + idx"
                    class="vrm-date-time-picker__dropdown__custom-time-dropdown__choice"
                    :class="{ active: time === selectedChoice }"
                    @mousedown.prevent="selectTime(time)"
                >
                    {{ time }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import moment from 'moment';

@Component
@AngularDirective('vrm-time-input')
export default class VrmTimeInput extends Vue {
    @Prop({ type: String, required: true })
    uniqueKeyString;
    @Prop({ type: String, required: true })
    maxTime;
    @Prop({ type: String, default: '00:00' })
    minTime;
    @Prop({ type: Number, default: 15 })
    interval;
    @Model('input')
    selectedTime;
    isDropdownOpen = false;
    value = null;
    mounted() {
        this.value = this.selectedTime;
    }

    @Watch('selectedTime')
    handleTimeSelect() {
        this.value = this.selectedTime;
    }

    get times() {
        return [...Array(24).keys()].flatMap(hour =>
            this.minutes.map(minute => `${String(hour).padStart(2, '0')}:${minute}`),
        );
    }

    get minutes() {
        let minuteStringsArray = ['00'];
        let minute = 0;
        while (minute < 60) {
            minute += this.interval;
            minuteStringsArray.push(String(minute).padStart(2, '0'));
        }
        return minuteStringsArray;
    }

    get timeChoices() {
        return this.times.filter(
            time =>
                moment(time, 'H:m', true) <= moment(this.maxTime, 'H:m', true) &&
                moment(time, 'H:m', true) >= moment(this.minTime, 'H:m', true),
        );
    }

    handleFocus() {
        this.isDropdownOpen = true;
        this.$nextTick(() => {
            const itemIndex = this.timeChoices.findIndex(time => this.selectedTime === time);
            if (itemIndex < 0) return;
            const choiceHeight = this.$refs.timeChoices.scrollHeight / this.timeChoices.length;
            this.$refs.timeChoices.scrollTop = choiceHeight * itemIndex;
        });
    }

    handleBlur() {
        this.isDropdownOpen = false;
        this.$emit('input', this.value);
    }

    selectTime(time) {
        this.value = time;
        this.$refs.input.blur();
    }

    get selectedChoice() {
        const momentObject = moment(this.value, 'H:m', true);
        if (!momentObject.isValid()) {
            return null;
        }
        return momentObject.format('HH:mm');
    }
}
</script>
